import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

import { useOrdersQuery } from 'api/queries/orderQueries';
import MetaTags from 'components/layout/header/MetaTags';
import { MarketSearchDropdown } from 'components/markets/MarketSearchDropdown';
import WalletDashboardContent from 'components/wallet/dashboard/WalletDashboardContent';
import { useNavigateToPrevious } from 'lib/redirect';
import { useSelector } from 'reduxState/store';

import OrderDetailScreen from '../detail/OrderDetailScreen';

import ActiveOrdersMultiMarketTable from './ActiveOrdersMultiMarketTable';

function OpenOrdersPage() {
  const isMobile = useSelector(state => state.screen.isMobile);
  const navigateToPrevious = useNavigateToPrevious('/wallet/open-orders');

  const [marketFilter, setMarketFilter] = useState('');

  const { data: activeOrders } = useOrdersQuery();

  const controlsDisabled = !activeOrders?.length && !marketFilter;

  // TODO: is this safe ? maybe we can check if it's format of correct ID (or length at min)
  const { orderUuid: activeDetailOrderUuid, fillId: activeDetailOrderFillId } =
    useParams<{ orderUuid?: string; fillId?: string }>();

  const detailScreen = activeDetailOrderUuid ? (
    <OrderDetailScreen
      orderUuid={activeDetailOrderUuid}
      highlightedFillId={activeDetailOrderFillId}
      showingOn="open-orders"
      onClose={navigateToPrevious}
    />
  ) : null;

  return isMobile && detailScreen ? (
    <>{detailScreen}</>
  ) : (
    <>
      {!isMobile && detailScreen && <>{detailScreen}</>}

      <MetaTags title="Open Orders" />

      <WalletDashboardContent
        title="Open Orders"
        showBalanceActions
        showStats
        headerContentRight={
          !isMobile ? (
            <MarketSearchDropdown
              selectedMarket={marketFilter}
              onSelect={setMarketFilter}
              disabled={controlsDisabled}
            />
          ) : undefined
        }
        headerBeforeBody={
          isMobile ? (
            <MarketSearchDropdown
              selectedMarket={marketFilter}
              onSelect={setMarketFilter}
              disabled={controlsDisabled}
            />
          ) : undefined
        }
      >
        <ActiveOrdersMultiMarketTable marketFilter={marketFilter} />
      </WalletDashboardContent>
    </>
  );
}

export default OpenOrdersPage;
